(function() {
  // Helper to remove quotes, line breaks, and trim whitespace
  const clean = s =>
    (s ?? '')
      .replace(/(^["']+|["'\n\r]+$)/g, '')
      .trim();

  function refreshCartDrawer() {
  if (window.theme && theme.CartDrawer) {
    theme.CartDrawer.open();
  } else {
    fetch(window.routes.cart_url + '?section_id=cart-drawer')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newBody = doc.querySelector('[data-cart-dynamic-content="cart-body"]');
        const newFooter = doc.querySelector('[data-cart-dynamic-content="cart-footer"]');

        const targetBody = document.querySelector('[data-cart-dynamic-content="cart-body"]');
        const targetFooter = document.querySelector('[data-cart-dynamic-content="cart-footer"]');

        if (newBody && targetBody) targetBody.innerHTML = newBody.innerHTML;
        if (newFooter && targetFooter) targetFooter.innerHTML = newFooter.innerHTML;
      })
      .catch(console.error);
  }
}


  // Ottiene in modo dinamico l'ID della variante bundle
  async function getBundleVariantId(bundleHandle, mainColor, upsellColor) {
    const res = await fetch(`/products/${bundleHandle}.js`);
    if (!res.ok) throw new Error(`Bundle prodotto non trovato: ${bundleHandle}`);
    const product = await res.json();

    // Se il bundle ha una sola variante, la restituisce direttamente
    if (product.variants.length === 1) {
      return product.variants[0].id;
    }

    // Debug: controlla i valori e le varianti disponibili
    console.log('Debug getBundleVariantId:', {
      bundleHandle,
      mainColor: JSON.stringify(mainColor),
      upsellColor: JSON.stringify(upsellColor),
      variants: product.variants.map(v => ({ opt1: v.option1, opt2: v.option2, id: v.id })),
      options: product.options
    });

    let variant;
    // Se il prodotto ha una sola opzione (es. option2 non utilizzata), match solo su option1
    if (product.options.length === 1) {
      variant = product.variants.find(v =>
        clean(v.option1) === clean(upsellColor) ||
        clean(v.option1) === clean(mainColor)
      );
    } else {
      // Altrimenti match su entrambe le opzioni
      variant = product.variants.find(v =>
        clean(v.option1) === clean(mainColor) &&
        clean(v.option2) === clean(upsellColor)
      );
    }

    if (!variant) {
      throw new Error(`Variante non trovata per: ${mainColor} + ${upsellColor}`);
    }
    return variant.id;
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.body.addEventListener('click', async event => {
      const btn = event.target.closest('.upsell-add-button');
      if (!btn) return;
      event.preventDefault();

      const card = btn.closest('.cart-drawer-upsell-product');
      const bundleHandle = card.dataset.bundleHandle;
      const mainColor    = card.dataset.mainColor;
      const selectEl     = card.querySelector('select.upsell-variant-select');
      const upsellColor  = selectEl ? selectEl.selectedOptions[0].textContent : '';

      if (!bundleHandle || !mainColor) {
        console.error('Dati insufficienti per getBundleVariantId:', { bundleHandle, mainColor, upsellColor });
        return;
      }

      const currentVid = btn.dataset.currentVariantId;
      if (!currentVid) {
        console.error('Missing current variant ID');
        return;
      }

      let bundleVid;
      try {
        bundleVid = await getBundleVariantId(bundleHandle, mainColor, upsellColor);
      } catch (e) {
        console.error('Errore recupero variante bundle:', e);
        return;
      }

      // Rimuove il prodotto principale
      try {
        const cartRes  = await fetch('/cart.js');
        const cartData = await cartRes.json();
        const line     = cartData.items.findIndex(i => i.variant_id == currentVid) + 1;
        if (!line) throw new Error('Prodotto principale non trovato nel carrello');
        await fetch('/cart/change.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ line, quantity: 0 })
        });
      } catch (e) {
        console.error('Errore rimozione prodotto principale:', e);
        return;
      }

      // Aggiunge la variante bundle
      try {
        await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ id: bundleVid, quantity: 1 })
        });
        refreshCartDrawer();
      } catch (e) {
        console.error('Errore aggiunta bundle:', e);
      }
    });

    // Nasconde la card upsell al click sulla X
    document.body.addEventListener('click', event => {
      const removeBtn = event.target.closest('.cart-drawer__upsell--remove');
      if (!removeBtn) return;
      event.preventDefault();
      const upsellCard = removeBtn.closest('.cart-drawer-upsell-product');
      if (upsellCard) upsellCard.style.display = 'none';
    });
  });
})();
